import React from 'react';
import {Link, generatePath} from 'react-router-dom';
import routes from 'globals/routes';
import { useDataValue } from 'globals/contexts/dataContext';

import './detailSection.css';

const DetailSection = (props) => {
  const [{currentLanguage}, dispatch] = useDataValue();
  const pageContent = props['content'];
  return <section className="details" id="details">
    <div class="title">{pageContent['title']}</div>
    {pageContent['media'] && <div className="iframeWrapper">
      <iframe src={pageContent['media']} />
    </div>}
    <div className="content" dangerouslySetInnerHTML={{
      __html: pageContent['text']
    }} />
  </section>;
}
export default DetailSection;